/*
 * @Author: 陶慧灵
 * @Date: 2022-10-21 09:20:20
 * @LastEditors: wenbei421 346972930@qq.com
 * @LastEditTime: 2022-11-17 14:46:33
 * @Descripttion:
 * @FilePath: \src\sys-area-index-examine.ts
 */
import icsChromelyRequest from '@icreate/ics-chromely-js-sdk'
import IndexExamine from './index-examine'
import { escapeSpecialCharacters } from './utils'

export default class SysAreaIndex {
  private static like = ['FULL_NAME', 'FULL_SPELL_CODE', 'FULL_STROKE_CODE']
  /**
   * 查询行政区划
   * @param category：分类,父行政区划编码
   * @param keys：关键字
   * @param rank：行政级别1~5，默认5
   * @returns 成功返回结果
   */
  public static query(category: string, keys: string = '', rank: number = 5): Promise<any> {
    if (icsChromelyRequest.isChromely) {
      return IndexExamine.query(
        'SysAreaIndex',
        '',
        this.QueryCondition(escapeSpecialCharacters(keys), rank, category)
      )
    } else {
      return IndexExamine.queryByServer('SysAreaIndex', '', keys, this.like, {
        PID: category, //做匹配  34* => like '34%'
        RANK: rank //范围查询 3  => <= 3
      })
    }
  }

  /**
   * 分页查询行政区划
   * @param indexId: 索引id
   * @param pageIndex：page索引
   * @param pageSize：page尺寸
   * @param category：分类,父行政区划编码
   * @param keys：关键字
   * @param rank：行政级别1~5，默认5
   * @returns 成功返回结果
   */
  public static page(
    pageIndex: number,
    pageSize: number,
    category: string,
    keys: string = '',
    rank: number = 5
  ): Promise<any> {
    if (icsChromelyRequest.isChromely) {
      return IndexExamine.page(
        'SysAreaIndex',
        pageIndex,
        pageSize,
        '',
        this.QueryCondition(escapeSpecialCharacters(keys), rank, category)
      )
    } else {
      return IndexExamine.pageByServer('SysAreaIndex', pageIndex, pageSize, '', keys, this.like, {
        PID: category, //做匹配  34* => like '34%'
        RANK: rank //范围查询 3  => <= 3
      })
    }
  }

  /**
   * 查询条件组装
   * @param keys
   * name:*安* spellCode:*安* strokeCode:*安*
   * http://icreate.com/LocalIndex/Page?indexId=SysAreaIndex&pageIndex=0&pageSize=10&category=&keys=name:*安* spellCode:*安* strokeCode:*安*
   * http://icreate.com/LocalIndex/Page?indexId=SysAreaIndex&pageIndex=0&pageSize=10&category=&keys=name:*安* spellCode:*安* strokeCode:*安* +rank:[1 TO 3]
   * http://icreate.com/LocalIndex/Page?indexId=SysAreaIndex&pageIndex=0&pageSize=10&category=34*&keys=name:*安* spellCode:*安* strokeCode:*安* +rank:[1 TO 3]
   * @returns
   */
  private static QueryCondition(keys: string, rank: number, category: string): string {
    // (name:"*安徽*" OR fullSpellCode:"*安徽*") AND pid:34* AND rank:[1 TO 3]
    let condition = []
    if (keys.trim()) {
      condition.push(
        `(fullName:"*${keys}*" OR fullSpellCode:*${keys}* OR fullStrokeCode:*${keys}*)`
      )
    }
    if (category.trim()) {
      condition.push(`pid:${category}`)
    }
    if (rank !== 5) {
      condition.push(`rank:[1 TO ${rank}]`)
    }
    return condition.join(' AND ')
  }
}
